//import axios from 'axios';
import axios from './axios';
import { useEffect } from "react";
import useAxiosPrivate from './useAxiosPrivate';
import {useNavigate, useLocation } from 'react-router-dom'


const useApi = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const navigateToLogin = () => {
        navigate('/', { state: { from: location }, replace: true });
    }

    const axiosPrivate = useAxiosPrivate();

    const sendPasswordResetOTP = async (params) => {
        try {
              // const response = await axios.post('https://localhost:44495/api/auth/sendPasswordResetOTP', 
                //const response = await axios.post('http://3.108.215.54:8080/api/auth/sendPasswordResetOTP', 
              const response = await axios.post('https://eauctionspicesboard.in/api/auth/sendPasswordResetOTP', 
                 params 
            , {
                headers: { 'Content-type': 'application/json' },
                withCredentials: true
            });

            return response.data;
        } catch (error) {
            //navigateToLogin();
        }
    };

    const validateOTP = async (params) => {
        try {
           // const response = await axios.post('https://localhost:44495/api/auth/validateOTP',  
                //const response = await axios.post('http://3.108.215.54:8080/api/auth/validateOTP',  
                const response = await axios.post('https://eauctionspicesboard.in/api/auth/validateOTP',  
                params
            , {
                headers: { 'Content-type': 'application/json' },
                withCredentials: true
            });

            return response.data;
        } catch (error) {
            //navigateToLogin();
        }
    };


    const getCompanies = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getCompanies`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getCompaniesDropdown = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getCompaniesDropdown`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const saveCompany = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/saveCompany`, params);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getAuctions = async (params) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getAuctions`, params);
            return response.data;

        } catch (error) {
            navigateToLogin();

        }
    };

    const saveAuction = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/saveAuction`, params);
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };
    const deleteAuction = async (auctionId) => {
        try {
            const response = await axiosPrivate.delete(`/api/admin/deleteAuction?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };



    const deleteAuctionSession = async (auctionId) => {
        try {
            const response = await axiosPrivate.delete(`/api/admin/deleteAuctionSession?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getLotDetails = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getLotDetails?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getLotOverview = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/GetLotOverview?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const deleteLotDetails = async (auctionId) => {
        try {
            const response = await axiosPrivate.delete(`/api/admin/deleteLotDetails?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const updateLotDetection = async (lot) => {
        try {
            const response = await axiosPrivate.put(`/api/admin/updateLotDetection`,lot);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const updateLotSkip = async (lot) => {
        try {
            const response = await axiosPrivate.put(`/api/auctioneer/updateLotSkip`, lot);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };


    const saveTradeSession = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/saveTradeSession`, params);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const getAuctioneers = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getAuctioneers`);
            return response.data;
        } catch (error) {
             navigateToLogin();
        }
    };

    const getAuctioneersDropdown = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getAuctioneersDropdown`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const saveAuctioneer = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/saveAuctioneer`, params);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const getAuctioneerLots = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/auctioneer/getAuctioneerLots?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
             navigateToLogin();
        }
    };

    const getAuctioneerDashboard = async () => {
        try {
            const response = await axiosPrivate.get(`/api/auctioneer/getAuctioneerDashboard`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getLotSummary = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/auctioneer/getAuctioneerLotSummary?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
             navigateToLogin();
        }
    };

    const getAuctioneerLotDetails = async (lotId) => {
        try {
            const response = await axiosPrivate.get(`/api/auctioneer/getAuctioneerLotDetail?lotId=${lotId}`);
            return response.data;
        } catch (error) {
             navigateToLogin();
        }
    };

    const saveTrader = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/saveTrader`, params);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const updateTraderStatus = async (params) => {
        try {
            const response = await axiosPrivate.put(`/api/admin/updateTraderStatus`, params);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const updateCanSkipOTP = async (params) => {
        try {
            const response = await axiosPrivate.put(`/api/auctioneer/updateCanSkipOTP`, params);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getTraders = async (traderId) => {
        try {
            if (traderId === undefined)
                traderId = 0;
            const response = await axiosPrivate.get(`/api/admin/getTraders?id=${traderId}`);
            return response.data;
        } catch (error) {
             navigateToLogin();
        }
    };

    const getPoolingTraders = async () => {
        try {
            const response = await axiosPrivate.get(`/api/pooler/getPoolingTraders`);
            return response.data;
        } catch (error) {
           // navigateToLogin();
        }
    };


    const saveLotPrice = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/auctioneer/saveLotPrice`, params);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const closeAuction = async (auctionId) => {
        try {
            const response = await axiosPrivate.put(`/api/auctioneer/closeAuction?auctionId=${auctionId}`);
            return response.data;

        } catch (error) {
            //navigateToLogin();
        }
    };

    const processLot = async (lotId) => {
        try {
            const response = await axiosPrivate.post(`/api/auctioneer/processLot?lotId=${lotId}`);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const startLot = async (lotId) => {
        try {
            const response = await axiosPrivate.post(`/api/auctioneer/startLot?lotId=${lotId}`);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const reRunLot = async (lotId) => {
        try {
            const response = await axiosPrivate.post(`/api/auctioneer/reRunLot?lotId=${lotId}`);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const placeBid = async (lotId) => {
        try {
            const response = await axiosPrivate.post(`/api/trader/placeBid?lotId=${lotId}`);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const getStreamerDashboard = async (lotId) => {
        try {
            const response = await axiosPrivate.post(`/api/streamer/getStreamerDashboard`);
            return response.data;

        } catch (error) {
             navigateToLogin();
        }
    };

    const downloadCsvErrorFile = async (filename) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/downloadCsvErrorFile?fileName=${filename}`, {
                responseType: 'blob',
            });
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };


    const logout = async () => {
        try {
            const response = await axiosPrivate.post(`/api/auth/logout`).then((response) => {
                if (response.data.success) {
                    navigate("/");
                }
                else
                    alert(response.data.message);
            }).catch((error) => {
                console.error('Unable to logout', error);
            });
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getCurrentConnectedTraders = async (lotId) => {
        try {
            const response = await axiosPrivate.get(`/api/auth/getCurrentConnectedTraders`);
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };

    const getCompletedLotsReport = async () => {
        try {
            const response = await axiosPrivate.get(`/api/trader/getCompletedLotsReport`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getConfirmedPurchasesReport = async () => {
        try {
            const response = await axiosPrivate.get(`/api/trader/getConfirmedPurchasesReport`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getTraderDashboard = async () => {
        try {
            const response = await axiosPrivate.get(`/api/trader/getTraderDashboard`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getOTPLoginHistory = async () => {
        try {
            const response = await axiosPrivate.get(`/api/auctioneer/GetOTPLoginHistory`);
            return response.data;
        } catch (error) {
            // navigateToLogin();
        }
    };
    const getReport = async ( reportName, optionalParams ) => {
        try {
            debugger
            const response = await axiosPrivate.post(`/api/admin/getReport?reportName=${reportName}`, optionalParams);
            return response.data;
        } catch (error) {
           // navigateToLogin();
        }
    };

    const downloadCSRAmountReport = async (reportName, optionalParams) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/downloadCSRAmountReport?reportName=${reportName}`, optionalParams, { responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            // navigateToLogin();
        }
    };

    const downloadUserFeeReport = async (reportName, optionalParams) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/downloadUserFeeReport?reportName=${reportName}`, optionalParams, { responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            // navigateToLogin();
        }
    };
    const downloadFullAuctionReport = async (reportName, optionalParams) => {
        try {
            debugger
            const response = await axiosPrivate.post(`/api/admin/downloadFullAuctionReport?reportName=${reportName}`, optionalParams, { responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            // navigateToLogin();
        }
    };
    const downloadMonthlyAuctionReport = async (reportName, optionalParams) => {
        try {
            debugger
            const response = await axiosPrivate.post(`/api/admin/downloadMonthlyAuctionReport?reportName=${reportName}`, optionalParams, { responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            // navigateToLogin();
        }
    };  
    const downloadWeeklyAuctionReport = async (reportName, optionalParams) => {
        try {
            debugger
            const response = await axiosPrivate.post(`/api/admin/downloadWeeklyAuctionReport?reportName=${reportName}`, optionalParams, { responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            // navigateToLogin();
        }
    };  

    const downloadTradingHistoryReport = async (reportName, optionalParams) => {
        try {
            debugger
            const response = await axiosPrivate.post(`/api/admin/downloadTradingHistoryReport?reportName=${reportName}`, optionalParams,{ responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            // navigateToLogin();
        }
    };
    

    const downloadReport = async (reportName, id) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/downloadReport?reportName=${reportName}&id=${id}`, { responseType: 'arraybuffer' });
            const contentDispositionHeader = response.headers['content-disposition'];
            const fileNameMatch = contentDispositionHeader.match(/filename\*?=['"]?(?:UTF-8['"])?([^;\r\n"']*)['"]?;?/i);
            let fileName = "DownloadedFile"; // Default file name if not found in headers
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = decodeURIComponent(fileNameMatch[1]);
            }
            return {
                fileName: fileName,
                fileData: response.data
            };
        } catch (error) {
            //console.log(error)
            //navigateToLogin();
        }
    };

    const getAuctionHistoryReport = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getAuctionHistoryReport`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getLotDetailReport = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getLotDetailReport?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getBidderDetailReport = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getBidderDetailReport?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getBiddingHistoryReport = async (lotId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getBiddingHistoryReport?lotId=${lotId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getCurrentTraderLoginReport = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getCurrentTraderLoginReport`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getLoginHistoryReport = async (startDate, endDate) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getLoginHistoryReport?startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const getPoolingCenters = async () => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getPoolingCenters`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };

    const savePoolingCenter = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/savePoolingCenter`, params);
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };

    const getPooledLots = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/pooler/getPooledLots?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    }

    const getPooledLotDetail = async (id) => {
        try {
            const response = await axiosPrivate.get(`/api/pooler/getPooledLotDetail?pooledLotId=${id}`);
            return response.data;
        } catch (error) {
            //navigateToLogin();
        }
    }


    const getPooledLotsForAuctionAdmin = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/pooler/getPooledLotsForAuctionAdmin?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    }

    const getPooledLotDetailForAuctionAdmin = async (id) => {
        try {
            const response = await axiosPrivate.get(`/api/pooler/getPooledLotDetailForAuctionAdmin?pooledLotId=${id}`);
            return response.data;
        } catch (error) {
            //navigateToLogin();
        }
    }

    const getPooledLotAuditTrail = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getPooledLotAuditTrail?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    }


    const savePooledLotDetail = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/pooler/savePooledLotDetail`, params);
            return response.data;

        } catch (error) {
            console.log(error);
            alert("Unable to process your request at this time.")
            //navigateToLogin();
        }
    };

    const closePooling = async () => {
        try {
            const response = await axiosPrivate.put(`/api/pooler/closePooling`);
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };
    const getPoolingDataForAuction = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/admin/getPoolingDataForAuction?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    }

    const getCropReceipt = async (pooledLotId) => {
        try {
            const response = await axiosPrivate.get(`/api/pooler/getCropReceipt?pooledLotId=${pooledLotId}`);
            return response.data;
        } catch (error) {
            console.log(error)
            //navigateToLogin();
        }
    }

    const addPooledLotsToAuction = async (auctionId) => {
        try {
            const response = await axiosPrivate.put(`/api/admin/addPooledLotsToAuction?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            //navigateToLogin();
        }
    }

    const deletePooledLot = async (pooledLotId) => {
        try {
            const response = await axiosPrivate.delete(`/api/pooler/deletePooledLot?pooledLotId=${pooledLotId}`);
            return response.data;
        } catch (error) {
           // navigateToLogin();
        }
    };

    const saveWithdrawSoldLot = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/admin/saveWithdrawSoldLot`, params);
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };

    const getPaymentDetails = async (auctionId) => {
        try {
            const response = await axiosPrivate.get(`/api/auctioneer/getPaymentDetails?auctionId=${auctionId}`);
            return response.data;
        } catch (error) {
            navigateToLogin();
        }
    };
    const savePaymentDetails = async (params) => {
        try {
            const response = await axiosPrivate.post(`/api/auctioneer/savePaymentDetails`, params);
            return response.data;

        } catch (error) {
            navigateToLogin();
        }
    };
    
    return {
        getCompanies,
        saveCompany,
        getCompaniesDropdown,
        getCurrentConnectedTraders,
        getAuctions,
        saveAuction,
        getLotDetails,
        getLotOverview,
        deleteLotDetails,
        saveTradeSession,
        getAuctioneers,
        saveAuctioneer,
        getAuctioneersDropdown,
        getAuctioneerLots,
        getLotSummary,
        getAuctioneerLotDetails,
        saveTrader,
        updateTraderStatus,
        getTraders,
        getPoolingTraders,
        saveLotPrice,
        closeAuction,
        processLot,
        startLot,
        reRunLot,
        placeBid,
        getTraderDashboard,
        getStreamerDashboard,
        downloadCsvErrorFile,
        deleteAuction,
        deleteAuctionSession,
        updateLotDetection,
        updateLotSkip,
        getAuctioneerDashboard,
        getCompletedLotsReport,
        getConfirmedPurchasesReport,
        getReport,
        getAuctionHistoryReport,
        getLotDetailReport,
        getBidderDetailReport,
        getBiddingHistoryReport,
        getCurrentTraderLoginReport,
        getLoginHistoryReport,
        downloadReport,
        getPoolingCenters,
        savePoolingCenter,
        getPooledLots,
        getPooledLotDetail,
        getPooledLotsForAuctionAdmin,
        getPooledLotDetailForAuctionAdmin,
        savePooledLotDetail,
        deletePooledLot,
        closePooling,
        getPoolingDataForAuction,
        getCropReceipt,
        addPooledLotsToAuction,
        downloadTradingHistoryReport,
        downloadFullAuctionReport,
        downloadMonthlyAuctionReport,
        downloadWeeklyAuctionReport,
        downloadCSRAmountReport,
        downloadUserFeeReport,
        sendPasswordResetOTP,
        validateOTP,
        updateCanSkipOTP,
        getOTPLoginHistory,
        getPooledLotAuditTrail,
        logout,
        saveWithdrawSoldLot,
        getPaymentDetails,
        savePaymentDetails
    };
}

export default useApi;

 